import React from "react";
import img from "../../assets/rocket.png";
import "./about.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

function Aboutwhychoose() {

      useEffect(() => {
      AOS.init({
        duration: 1000, // animation duration (1 second)
        once: true,     // animation happens only once
      });
    }, []);
  return (
    <section className="about-whychoose-section">
      <div className="about-whychoose-container">
        {/* Left side - text */}
        <div className="about-whychoose-text" data-aos="fade-up">
          <h4>WHY CHOOSE US</h4>
          <h2>
            Your vision, our expertise – together creating <br />
            digital success
          </h2>
          <p>
            Choose us for a seamless blend of creativity, expertise, and
            commitment to your success.
            <br>
            </br> We deliver customized website designs,
            effective digital marketing strategies, and <br>
            </br>impactful SEO solutions
            that drive real results. With a focus on quality and<br>
            </br>  client
            satisfaction, we make your goals our priority.
          </p>
        </div>

      </div>
    </section>
  );
}

export default Aboutwhychoose;
